import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tooltip, Typography, Grid, Button, Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CompareArrows as CompareArrowsIcon, Message as MessageIcon } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux'
import { faAngleUp, faAngleDown, faSyncAlt, faCalendarCheck, faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle, faThumbsUp } from '@fortawesome/pro-light-svg-icons';
import { getValidationFailureMessages } from '../../../Utils/ValidationFailureFormatter';
import { Card, CardContent } from '@mui/material';
import { DataGrid, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import ReactSelect from "../../../../common/components/UI/Select/ReactSelect";
import { AdditionalInfo } from '../../../../common-client2/src/components';
import { getAsLongDate, getAsStartAndEndTimeFormat, getAsLongDateTime, formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { hasTransfer } from '../../../auxilaries'
import { MTV_CLASSES } from '../managerTableViewClasses';
import TooltipDataviewEmployee from '../../../../common/components/UI/ToolTip/TooltipDataviewEmployee';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { ShiftCardWithTooltip } from '../ShiftCardWithTooltip';
import {
    RequestTypes, RequestSubtypes, ShiftSegmentTypeName, RequestStatus,
} from '../../../Enums'
import { updateFetchSizeOption } from '../actions'
import ManagerWarningContent from '../ManagerWarningContent';
import SubmissionPeriodLabel from './SubmissionPeriodLabel';
import RequestTypeChip from '../RequestTypeChip';
import { GetModifiedBy } from '../helpers/ManageRequests.helper';
import RequestDetailPanel from '../helpers/RequestDetailPanel';
import './dataviewTable.scss';

const WarnTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: 'white',
        color: '#3A3A3A',
        maxWidth: '520px',
        border: '1px solid #dadde9',
    },
});

const displayDurationInHours = (segment) => `[${(new Date(segment.endDateTime) - new Date(segment.startDateTime)) / 1000 / 60 / 60}]`;


class DataviewTable extends React.Component {
    constructor(props) {
        super(props);
        this.theme = createTheme({
            palette: {
                primary: {
                    main: '#66b3ff',
                },
                secondary: {
                    main: '#66b3ff',
                },
            },

        });
        this.state = {
            opened: false,
            expandedRowKey: null,
        }
    }

    handleSelectFetchSize = (target, value) => {
        this.props.updateFetchSizeOption(value);
    }

    toggleExpand = (key) => {
        this.setState(prev => ({ expandedRowKey: prev.expandedRowKey === key ? null : key }));
    }

    /* generateSchedule + generateShiftColors + getChipClass extracted to ../helpers/ManageRequests.helper.js */

    generateColumns = (managerSetting, requestColumns, employee1Columns, employee2Columns, dataviewsData, classes) => {
        let columns = [];
        for (let x of requestColumns) {
            if (x.Active) {
                if (x.Dataview) {
                    //                 columns.push(this.generateDataviewColumn(x)); Non existant?
                } else {
                    columns.push(this.generateDefaultRequestColumn(x, classes));
                }
            }
        }

        switch (managerSetting.type) {
            case RequestTypes.toCover:
            case RequestTypes.shiftSwap:
                for (let x of employee1Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            this.pushDataviewColumns(columns, x, 1, dataviewsData);
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 1));
                        }
                    }
                }

                for (let x of employee2Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            this.pushDataviewColumns(columns, x, 2, dataviewsData);
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 2));
                        }
                    }
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                for (let x of employee1Columns) {
                    if (x.Active) {
                        if (x.Dataview) {
                            this.pushDataviewColumns(columns, x, 1, dataviewsData);
                        } else {
                            columns.push(this.generateDefaultEmployeeColumn(x, classes, 1));
                        }
                    }
                }
                break;
            default:
                break;
        }


        return columns.filter(x => x != null);
    }

    getEmployee(rowData, empFromTo) {
        let employee;

        switch (rowData.actionType) {
            case RequestTypes.toCover:
                switch (empFromTo) {
                    case 1:
                        employee = rowData.employeeFrom.id;
                        break;
                    case 2:
                        employee = rowData.employeeTo.id;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        employee = rowData.offerorEmployeeId;
                        break;
                    case 2:
                        employee = rowData.swapProposal.proposalEmployeeIdentifier;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                employee = rowData.employeeTo.id;
                break;
            default:
                break;
        }
        return employee;
    }

    getDataviewData(rowData, dataviewsData, dataviewKey, empFromTo) {
        const employee = this.getEmployee(rowData, empFromTo);

        if (employee) {
            const employeeData = dataviewsData[employee];
            if (employeeData) {
                var key = rowData.startDate ? formatAs(rowData.startDate, DateFnsFormats.YMD) : 'ANY';
                let d = dataviewsData[employee][key];
                if (!d) {
                    d = dataviewsData[employee]['ANY'];
                }
                if (d) {
                    let wantedData = d.attributes.find(x => x.key === dataviewKey);
                    if (wantedData) {
                        return wantedData.value;
                    }
                }
            }
        }
        return "";
    }

    generateDataviewColumn(row, empFromTo, dataviewsData) {
        return {
            title: row.Label,
            render: rowData => {
                return <React.Fragment>
                    {this.getDataviewData(rowData, dataviewsData, row.DataviewKey, empFromTo)}
                </React.Fragment>;
            },
            customSort: (a, b) => {
                let valueA = this.getDataviewData(a, dataviewsData, row.DataviewKey, empFromTo)
                let valueB = this.getDataviewData(b, dataviewsData, row.DataviewKey, empFromTo)
                return valueA < valueB ? -1 : 1
            }
        };
    }

    /*
     * Under multiple assignments, a single dataview field can return one value per assignment
     * (each attribute carries an assignmentId). We render one column per positional assignment
     * ("Assignment 1", "Assignment 2", ...) up to the max any employee has in the current result,
     * and show the assignment name inside each cell since a column mixes roles across employees.
     * Assignment-independent fields (no assignmentId on any attribute) keep their single column.
     */
    pushDataviewColumns(columns, row, empFromTo, dataviewsData) {
        if (this.isAssignmentSpecificKey(dataviewsData, row.DataviewKey)) {
            const maxAssignments = this.getMaxAssignmentCount(dataviewsData);
            for (let i = 0; i < maxAssignments; i++) {
                columns.push(this.generateAssignmentDataviewColumn(row, empFromTo, dataviewsData, i));
            }
        } else {
            columns.push(this.generateDataviewColumn(row, empFromTo, dataviewsData));
        }
    }

    // True when any attribute for this dataview key is scoped to a specific assignment.
    isAssignmentSpecificKey(dataviewsData, dataviewKey) {
        for (const employeeId of Object.keys(dataviewsData || {})) {
            const employeeData = dataviewsData[employeeId];
            for (const dateKey of Object.keys(employeeData || {})) {
                const attributes = (employeeData[dateKey] && employeeData[dateKey].attributes) || [];
                if (attributes.some(a => a.key === dataviewKey && a.assignmentId)) {
                    return true;
                }
            }
        }
        return false;
    }

    // Distinct assignments for an employee, derived from their attributes, sorted by name for a stable positional order.
    getEmployeeAssignments(dataviewsData, employeeId) {
        const employeeData = dataviewsData && dataviewsData[employeeId];
        if (!employeeData) {
            return [];
        }
        const byId = new Map();
        for (const dateKey of Object.keys(employeeData)) {
            const attributes = (employeeData[dateKey] && employeeData[dateKey].attributes) || [];
            for (const a of attributes) {
                if (a.assignmentId && !byId.has(a.assignmentId)) {
                    byId.set(a.assignmentId, a.assignmentName || a.assignmentId);
                }
            }
        }
        return Array.from(byId, ([assignmentId, assignmentName]) => ({ assignmentId, assignmentName }))
            .sort((x, y) => (x.assignmentName < y.assignmentName ? -1 : 1));
    }

    // How many positional assignment columns to render: the max any single employee has.
    getMaxAssignmentCount(dataviewsData) {
        let max = 0;
        for (const employeeId of Object.keys(dataviewsData || {})) {
            const count = this.getEmployeeAssignments(dataviewsData, employeeId).length;
            if (count > max) {
                max = count;
            }
        }
        return max;
    }

    // Resolves the attribute + assignment for a given positional index (null when the employee has no assignment there).
    getAssignmentAttribute(rowData, dataviewsData, dataviewKey, empFromTo, positionIndex) {
        const employee = this.getEmployee(rowData, empFromTo);
        if (!employee) {
            return null;
        }
        const assignment = this.getEmployeeAssignments(dataviewsData, employee)[positionIndex];
        if (!assignment) {
            return null;
        }
        const employeeData = dataviewsData[employee];
        if (!employeeData) {
            return null;
        }
        const key = rowData.startDate ? formatAs(rowData.startDate, DateFnsFormats.YMD) : 'ANY';
        const d = employeeData[key] || employeeData['ANY'];
        if (!d) {
            return null;
        }
        const attribute = d.attributes.find(x => x.key === dataviewKey && x.assignmentId === assignment.assignmentId);
        return attribute ? { assignment, attribute } : null;
    }

    getDataviewValueForAssignment(rowData, dataviewsData, dataviewKey, empFromTo, positionIndex) {
        const found = this.getAssignmentAttribute(rowData, dataviewsData, dataviewKey, empFromTo, positionIndex);
        return found ? found.attribute.value : '';
    }

    generateAssignmentDataviewColumn(row, empFromTo, dataviewsData, positionIndex) {
        return {
            title: `${row.Label} — Assignment ${positionIndex + 1}`,
            render: rowData => {
                const found = this.getAssignmentAttribute(rowData, dataviewsData, row.DataviewKey, empFromTo, positionIndex);
                if (!found) {
                    return <React.Fragment />;
                }
                return <React.Fragment>{`${found.assignment.assignmentName}: ${found.attribute.value}`}</React.Fragment>;
            },
            customSort: (a, b) => {
                let valueA = this.getDataviewValueForAssignment(a, dataviewsData, row.DataviewKey, empFromTo, positionIndex);
                let valueB = this.getDataviewValueForAssignment(b, dataviewsData, row.DataviewKey, empFromTo, positionIndex);
                return valueA < valueB ? -1 : 1;
            }
        };
    }

    getEmployeeName(rowData, empFromTo) {
        let name;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                switch (empFromTo) {
                    case 1:
                        name = rowData.employeeFrom.name;
                        break;
                    case 2:
                        name = rowData.employeeTo.name;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        name = rowData.offerorEmployeeName;
                        break;
                    case 2:
                        name = rowData.swapProposal.proposalEmployeeName;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                name = rowData.employeeTo.name;
                break;
            default:
                break;
        }
        return name;
    }

    getRelevantDate = (rowData, empFromTo) => {
        let date;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
            case RequestTypes.openShift:
                date = rowData.shift.startDateTime;
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        date = rowData.swapRequestShiftInfo[0].startDateLocationTime;
                        break;
                    case 2:
                        date = rowData.swapProposalShiftInfo[0].startDateLocationTime;
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.voluntaryTimeOff:
                // EE1 only!
                date = rowData.startDate;
                break;
            default:
                break;
        }
        return formatAs(date, DateFnsFormats.YMD);
    }

    getEmployeeShift(rowData, empFromTo, classes) {
        let shiftCard;

        switch (rowData.actionType) {
            case RequestTypes.toCover:
                // EE1 only!
                shiftCard = (<ShiftCardWithTooltip
                    shift={rowData.shift}
                    partialShift={rowData.isPartial ? rowData.partialShift : null}
                    actionType={rowData.actionType}
                    isLargeShiftTimeText
                    timeOffRequest={rowData.timeOffRequest}
                    selectedAssignmentName={rowData.selectedAssignmentName}
                />);
                break;
            case RequestTypes.shiftSwap:
                switch (empFromTo) {
                    case 1:
                        return (
                            rowData.swapRequestShiftInfo.length <= 1
                                ?
                                <ShiftCardWithTooltip
                                    shift={rowData.swapRequestShiftInfo[0].shift}
                                    partialShift={rowData.partialOfferShift ? rowData.partialOfferShift : null}
                                    actionType={rowData.actionType}
                                    isLargeShiftTimeText
                                    selectedAssignmentName={rowData.offeredShiftAssignmentName}
                                />
                                :
                                <Button className={classes.transparentButtonNoPadding}>
                                    <Card className={classes.SSShiftCard}>
                                        <CardContent className={classes.fixPadding}>
                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                {rowData.swapRequestShiftInfo.length + "  Shifts"}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Button>
                        )
                    case 2:
                        return (
                            rowData.swapRequestShiftInfo.length <= 1//TODO : supposed to be swapProposalShiftInfo?
                                ?
                                <ShiftCardWithTooltip
                                    shift={rowData.swapProposalShiftInfo[0].shift}
                                    partialShift={rowData.isPartialProposal ? rowData.partialProposalShift : null}
                                    actionType={rowData.actionType}
                                    isLargeShiftTimeText
                                    selectedAssignmentName={rowData.selectedAssignmentName}
                                />
                                :
                                <Button className={classes.transparentButtonNoPadding}>
                                    <Card className={classes.SSShiftCard}>
                                        <CardContent className={classes.fixPadding}>
                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                {rowData.swapProposalShiftInfo.length + "  Shifts"}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Button>
                        )
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
                shiftCard = (
                    <ShiftCardWithTooltip
                        shift={rowData.shift}
                        partialShift={rowData.isPartial ? rowData.partialShift : null}
                        actionType={rowData.actionType}
                        isLargeShiftTimeText
                        isApproved={rowData.status.label === 'Approved'}
                        selectedAssignmentName={rowData.selectedAssignmentName}
                    />
                )
                break;
            case RequestTypes.voluntaryTimeOff: {
                let shifts = [];
                if (rowData.voluntaryTimeOffType === 2) {
                    shifts = rowData.status.value !== RequestStatus.RetractedSubmitted ? rowData.previousShiftsHistory : (rowData.shifts ? rowData.shifts.map(x => x.shift) : []);
                } else {
                    shifts = rowData.shifts?.map(x => x?.shift) ?? [];
                }

                return (
                    (!!shifts && shifts.length === 1)
                        ?
                        <ShiftCardWithTooltip
                            shift={shifts[0]}
                            partialShift={rowData.partialShift}
                            actionType={rowData.actionType}
                            isLargeShiftTimeText
                            isApproved={rowData.status.label === 'Approved'}
                            isVto={true}
                        />
                        :
                        <Button className={classes.transparentButtonNoPadding}>
                            <Card className={rowData.status.label === 'Approved' ? classes.VTOShiftCard : classes.VTOShiftCardApproved}>
                                <CardContent className={classes.fixPadding}>
                                    <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                        {(shifts?.length ?? 0) + "  Shifts"}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Button>
                )
            }
            default:
                return null
        }
        return shiftCard;
    }

    generateDefaultEmployeeColumn(row, classes, empFromTo) {
        const { employee1Columns, employee2Columns, dataviewsData, managerSetting } = this.props
        let columns = empFromTo === 1 ? employee1Columns : employee2Columns

        switch (row.DataviewKey) {
            case "DEFAULT__EMPLOYEE_NAME":
                return {
                    title: empFromTo === 1 ? 'Employee 1' : 'Employee 2',
                    cellStyle: {
                        borderLeft: '2px solid #CCCCCC'
                    },
                    headerStyle: {
                        borderLeft: '2px solid #CCCCCC'
                    },
                    render: rowData => {
                        let content = this.getEmployeeName(rowData, empFromTo)
                        let employee = this.getEmployee(rowData, empFromTo);
                        if (columns.length > 0 && employee !== undefined && dataviewsData[employee] !== undefined) {
                            let relevantDate = this.getRelevantDate(rowData, empFromTo);
                            let d = dataviewsData[employee][relevantDate]
                            if (!d) {
                                d = dataviewsData[employee]['ANY'];
                            }
                            if (d) {
                                content = <TooltipDataviewEmployee
                                    listCol={columns}
                                    data={d.attributes}
                                    employeeName={content}
                                />
                            }
                        }
                        return content;
                    }
                };
            case "DEFAULT__SHIFT":
                return {
                    title: managerSetting.type === 3 ? 'VTO' : 'Shift',
                    headerStyle: {
                        width: '1700px'
                    },
                    sorting: false,
                    render: rowData => {
                        return <React.Fragment>
                            {this.getEmployeeShift(rowData, empFromTo, classes)}
                        </React.Fragment>;
                    }
                };
            case "DEFAULT__AWARDING":
                return (managerSetting.adminSettings[0].awardingRuleEnabled ?
                    {
                        title: <div style={{ textAlign: 'center' }}>Award status</div>,
                        sorting: false,
                        render: rowData => {
                            const isGrey = (rowData.status.value === 3 && rowData.awardingResult);
                
                            return (
                                <React.Fragment>
                                    {rowData.awardingResult && (
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <FontAwesomeIcon
                                                icon={faThumbsUp}
                                                style={{ color: isGrey ? 'grey' : 'black' }}
                                            />
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        }
                    }
                    : null

                )
            case "DEFAULT__SENIORITY":
                return (managerSetting.adminSettings[0].awardingRuleEnabled ?
                    {
                        title: <div style={{ textAlign: 'center' }}>Seniority rank</div>,
                        sorting: false,
                        render: rowData => {
                            return <React.Fragment>
                                {rowData.awardingResultDetails && <div style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>{rowData.awardingResultDetails.value}</div>}
                            </React.Fragment>;
                        }
                    }
                    : null
                )
            default:
                break;
        }
    }

    getRequestDate(rowData) {
        switch (rowData.actionType) {
            case RequestTypes.toCover:
            case RequestTypes.openShift:
                return rowData.shift.startDateTime;
            case RequestTypes.shiftSwap:
                return rowData.startDate;
            case RequestTypes.voluntaryTimeOff:
                //rowData.startDate: "2023-11-03T00:00:00+00:00" -> Must remove the +00:00
                const startDateInLocalTz = new Date(rowData.startDate);
                const localOffset = startDateInLocalTz.getTimezoneOffset();
                const startDate = new Date(startDateInLocalTz.getTime() + localOffset * 60000);
                return startDate;
            default:
                break;
        }
    }

    generateDefaultRequestColumn(row, classes) {

        switch (row.DataviewKey) {
            case "DEFAULT__DATE":
                return {
                    title: 'Date submitted',
                    cellStyle: {
                        whiteSpace: 'nowrap',
                    },
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                return (
                                    <React.Fragment>
                                        {getAsLongDateTime(rowData.requestDate)}
                                    </React.Fragment>
                                );
                            case RequestTypes.shiftSwap:
                                return (
                                    <React.Fragment>
                                        {getAsLongDateTime(rowData.submissionDate)}
                                    </React.Fragment>
                                );
                            default:
                                break;
                        }
                    },
                    customSort: (a, b) => {
                        let dateA, dateB;
                        if (a.actionType === RequestTypes.shiftSwap) {
                            dateA = formatAs(a.submissionDate, DateFnsFormats.ISO);
                        }
                        else {
                            dateA = formatAs(a.requestDate, DateFnsFormats.ISO);
                        }

                        if (b.actionType === RequestTypes.shiftSwap) {
                            dateB = formatAs(b.submissionDate, DateFnsFormats.ISO);
                        } else {
                            dateB = formatAs(b.requestDate, DateFnsFormats.ISO);
                        }

                        return dateA < dateB ? -1 : 1
                    }
                }
            case "DEFAULT__DATE_REQUESTED":
                return {
                    title: 'Date requested',
                    cellStyle: {
                        maxWidth: 20
                    },
                    render: rowData => {
                        return (
                            <React.Fragment>
                                {getAsLongDate(this.getRequestDate(rowData))}
                            </React.Fragment>
                        )
                    },
                    customSort: (a, b) => {
                        const dateA = formatAs(this.getRequestDate(a), DateFnsFormats.ISO);
                        const dateB = formatAs(this.getRequestDate(b), DateFnsFormats.ISO);

                        return dateA < dateB ? -1 : 1
                    }
                }

            case "DEFAULT__REQUEST_TYPE":
                return {
                    title: 'Request type',
                    width: '5',
                    maxWidth: '5',
                    render: rowData => {
                        return (
                            <React.Fragment>
                                <RequestTypeChip request={rowData} classes={classes} />
                            </React.Fragment>
                        )
                    },
                    customSort: (a, b) => {
                        return a.requestType < b.requestType ? -1 : 1
                    }
                };
            case "DEFAULT__STATUS":
                return {
                    title: 'Status',
                    headerStyle: {
                        width: '115px'
                    },
                    sorting: false,
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift:
                            case RequestTypes.voluntaryTimeOff:
                                return (
                                    <div className="dataviewTable--status-cell">
                                        <Typography component={'h2'} >
                                            {rowData.status.label}
                                        </Typography>
                                        {
                                            (rowData.messages?.length)
                                                ? (
                                                    <AdditionalInfo
                                                        icon={<MessageIcon className="message-icon" />}
                                                        placement="auto"
                                                    >
                                                        {
                                                            rowData.messages.map(log => (
                                                                <div>
                                                                    <span className="text-lg-regular">
                                                                        {`${log.employeeName}: "${log.message}"`}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        }
                                                    </AdditionalInfo>
                                                )
                                                : <></>
                                        }
                                    </div>
                                )
                            default:
                                break;
                        }
                    }
                };
            case "DEFAULT__WARNING":
                return {
                    title: 'Warning',
                    field: 'warning',
                    sorting: false,
                    render: rowData => {
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift: {
                                const tooltipContent = [];
                                if (rowData['warnings'].length) {
                                    rowData['warnings'].forEach((warn, i) => tooltipContent.push(<ManagerWarningContent key={`w-${i}`} warning={warn} classes={classes} />));
                                }
                                if (rowData.validationFailures?.length > 0) {
                                    getValidationFailureMessages({ validationFailureDetails: rowData.validationFailures }, this.props.t)
                                        .forEach((msg, i) => tooltipContent.push(<div key={`v-${i}`}>{msg}</div>));
                                }
                                return (
                                    tooltipContent.length > 0 ?
                                        <React.Fragment>
                                            <WarnTooltip title={tooltipContent}>
                                                <Button className={classes.transparentButton}>
                                                    <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                </Button>
                                            </WarnTooltip>
                                        </React.Fragment>
                                        :
                                        null
                                )
                            }
                            case RequestTypes.voluntaryTimeOff: {
                                let warningMsgs;
                                if (rowData['warnings'].length) {
                                    warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                }
                                return (
                                    warningMsgs ?
                                        <React.Fragment>
                                            <WarnTooltip
                                                title={warningMsgs}>
                                                <Button className={classes.transparentButton}>
                                                    <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                </Button>
                                            </WarnTooltip>
                                        </React.Fragment>
                                        :
                                        null
                                )
                            }
                            default:
                                break;
                        }
                    }

                };
            case "DEFAULT__APPROVE_BY":
                return {
                    title: 'Modified by',
                    field: 'approvedByManagerName',
                    sorting: false,
                    render: rowData => {
                        return (
                            <React.Fragment>
                                <Typography>
                                    {GetModifiedBy(rowData.status.value, rowData.approvedByManagerName)}
                                </Typography>
                            </React.Fragment>
                        )
                    }
                };
            default:
                break;
        }
        return null;
    }


    computeRowDisabled = (rowData) => {
        const { activeSubmissionPeriodSettingsWithAwarding, signUpRequestSelected, isNonActiveSignUpRequestSelected } = this.props;
        const isRefusedButOverridable = rowData.status.value === RequestStatus.Refused && rowData.isManualOverrideAllowed;
        return ([RequestStatus.RetractedSubmitted, RequestStatus.Approved].includes(rowData.status.value) ||
            (rowData.status.value === RequestStatus.Refused && !isRefusedButOverridable)) ||
            (signUpRequestSelected && !activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId)) ||
            (isNonActiveSignUpRequestSelected && activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId));
    }

    toGridColumns = (mtColumns) => mtColumns.filter(Boolean).map((c, idx) => {
        const headerStyle = c.headerStyle || {};
        const cellStyle = c.cellStyle || {};
        const widthRaw = headerStyle.width;
        const widthNum = typeof widthRaw === 'string' ? parseInt(widthRaw, 10) : widthRaw;
        const sortable = c.sorting !== false;
        const hasTitle = typeof c.title === 'string' && !!c.title;
        const isGroupStart = !!(headerStyle.borderLeft || cellStyle.borderLeft);
        const innerCellStyle = (() => {
            if (!c.cellStyle) return null;
            const { borderLeft: _bl, borderRight: _br, borderTop: _bt, borderBottom: _bb, border: _b, ...rest } = c.cellStyle;
            return Object.keys(rest).length > 0 ? rest : null;
        })();
        const def = {
            field: c.field || `col_${idx}`,
            headerName: typeof c.title === 'string' ? c.title : '',
            sortable,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const content = c.render ? c.render(params.row) : params.value;
                return innerCellStyle ? <div style={innerCellStyle}>{content}</div> : content;
            },
        };
        const headerClasses = [];
        if (hasTitle && !sortable) headerClasses.push('mt-static-header');
        if (isGroupStart) headerClasses.push('group-divider');
        if (headerClasses.length > 0) def.headerClassName = headerClasses.join(' ');
        if (isGroupStart) def.cellClassName = 'group-divider';
        if (typeof c.title !== 'string') {
            def.renderHeader = () => c.title;
        }
        if (def.headerName === 'Employees' || def.headerName === 'Shift' || def.headerName === 'VTO') {
            def.width = 500;
        } else if (def.headerName === 'Warning') {
            def.width = 110;
        } else if (!hasTitle) {
            def.width = 90;
        } else if (widthNum && widthNum > 0 && widthNum <= 120) {
            def.width = Math.max(widthNum, 100);
        } else if (widthNum && widthNum > 800) {
            def.width = 280;
        } else {
            def.width = 160;
        }
        if (c.customSort) {
            def.valueGetter = (_value, row) => row;
            def.sortComparator = (a, b) => c.customSort(a, b);
        }
        return def;
    });

    renderTable() {
        let { data, dataviewsData, requestColumns, employee1Columns, employee2Columns, managerSetting, fetchResultData, onCheckedRequest, checkedRequests, OpenShiftKeyTable } = this.props;
        const classes = MTV_CLASSES;
        let mtColumns = this.generateColumns(managerSetting, requestColumns, employee1Columns, employee2Columns, dataviewsData, classes);
        const gridColumns = this.toGridColumns(mtColumns);
        const baseRowKey = (row) => {
            const idPart = row.requestId != null ? `req-${row.requestId}` : `offer-${row.offerId}`;
            return `${row.actionType}|${idPart}|${row.submissionDate || ''}`;
        };
        const getRowKey = (row) => row.__isDetail__ ? `detail-${row.__parentKey__}` : baseRowKey(row);
        const selectedIds = (checkedRequests || []).map(baseRowKey);
        const firstActionType = data[0]?.actionType;
        const showLoadMore = data.length > 0;
        const { expandedRowKey } = this.state;

        const rowsWithDetail = [];
        data.forEach(row => {
            rowsWithDetail.push(row);
            const key = baseRowKey(row);
            if (key === expandedRowKey && row.detailPanel) {
                rowsWithDetail.push({ ...row, __isDetail__: true, __parentKey__: key });
            }
        });

        const expandColumn = {
            field: '__expand',
            headerName: '',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            disableReorder: true,
            width: 50,
            colSpan: (value, row) => row.__isDetail__ ? 999 : 1,
            cellClassName: (params) => params.row.__isDetail__ ? 'detail-cell' : '',
            renderCell: (params) => {
                if (params.row.__isDetail__) {
                    return (
                        <div style={{ width: '100%' }}>
                            <RequestDetailPanel rowData={params.row} classes={classes} />
                        </div>
                    );
                }
                if (!params.row.detailPanel) return null;
                const key = baseRowKey(params.row);
                const isExpanded = expandedRowKey === key;
                return (
                    <FontAwesomeIcon
                        icon={isExpanded ? faChevronUp : faChevronDown}
                        className={classes.plusMinus}
                        size="lg"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => { e.stopPropagation(); this.toggleExpand(key); }}
                    />
                );
            },
        };

        const checkboxColumn = { ...GRID_CHECKBOX_SELECTION_COL_DEF };

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={this.theme} >
                    <DataGrid
                        rows={rowsWithDetail}
                        columns={[expandColumn, checkboxColumn, ...gridColumns]}
                        getRowId={getRowKey}
                        getRowHeight={(params) => (params.model && params.model.__isDetail__) ? 'auto' : null}
                        getEstimatedRowHeight={() => 200}
                        autoHeight={!!OpenShiftKeyTable}
                        checkboxSelection
                        disableRowSelectionOnClick
                        isRowSelectable={({ row }) => !row.__isDetail__ && !this.computeRowDisabled(row)}
                        rowSelectionModel={selectedIds}
                        onRowSelectionModelChange={(ids) => {
                            const idSet = new Set(ids);
                            const localSelected = data.filter(r => idSet.has(baseRowKey(r)));
                            const localKeys = new Set(data.map(baseRowKey));
                            const otherGroupsSelected = (checkedRequests || []).filter(r => !localKeys.has(baseRowKey(r)));
                            onCheckedRequest([...otherGroupsSelected, ...localSelected]);
                        }}
                        disableColumnFilter
                        disableColumnSelector
                        localeText={{ noRowsLabel: 'No records to display' }}
                        sx={{
                            backgroundColor: '#FFFFFF',
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f0f4f8',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: '#f0f4f8',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 900,
                                fontSize: '14px',
                            },
                            '& .mt-static-header .MuiDataGrid-columnHeaderTitle': {
                                textDecoration: 'underline',
                            },
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                alignItems: 'center',
                                paddingTop: '12px',
                                paddingBottom: '12px',
                            },
                            '& .MuiDataGrid-cell.group-divider, & .MuiDataGrid-columnHeader.group-divider': {
                                borderLeft: '2px solid #CCCCCC',
                            },
                            '& .MuiDataGrid-cell.detail-cell': {
                                padding: 0,
                            },
                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                outline: 'none',
                            },
                            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                outline: 'none',
                            },
                        }}
                        slots={{
                            toolbar: () => (
                                <div>
                                    <Grid container >
                                        <Grid item xs={3} md={3} lg={2}>
                                            <Typography className={classes.labelViews}>
                                                {selectedIds.length > 0 ? `${selectedIds.length} selected` : ''}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8} md={8} lg={9} style={{ display: "flex", alignItems: "center" }}>
                                            {firstActionType === RequestTypes.voluntaryTimeOff && (
                                                <SubmissionPeriodLabel request={data[0]} classes={classes} />)
                                            }
                                        </Grid>
                                        <Grid item xs={1} md={1} lg={1} style={{ textAlign: "right", padding: "7px" }} >
                                            <ReactSelect
                                                value={this.props.selectedFetchSize}
                                                options={this.props.fetchSizeOptions}
                                                onChange={this.handleSelectFetchSize}
                                                customStyles={{
                                                    control: styles => ({
                                                        ...styles,
                                                        margin: '5px 5px 5px 5px',
                                                        border: '1px solid #CCCCCC',
                                                        padding: 3,
                                                        height: 25,
                                                        minWidth: 91
                                                    }),
                                                    menu: styles => ({
                                                        ...styles,
                                                        zIndex: 100
                                                    })
                                                }}
                                                selectWrapperClass={classes.selectWrapper}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            ),
                            footer: showLoadMore ? () => (
                                <div style={{ textAlign: 'center', padding: '8px', borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
                                    <div>
                                        <Typography className={classes.labelViews}>You've viewed {fetchResultData.viewed} of {fetchResultData.total} requests</Typography>
                                    </div>
                                    <div>
                                        <Button mt={1} hidden={this.props.addMoreDisable} className={classes.buttonAddMore} onClick={() => this.props.addMoreRequests()}>
                                            <Typography className={classes.labelButtons}>Load more requests</Typography>
                                        </Button>
                                    </div>
                                </div>
                            ) : () => null,
                        }}
                        slotProps={{
                            toolbar: { showQuickFilter: false },
                        }}
                    />
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }

    toggleCollapsable() {
        this.setState({
            opened: !this.state.opened
        });
    }

    render() {

        let { t, OpenShiftKeyTable, managerSetting, data } = this.props;
        const classes = MTV_CLASSES;

        const displaySegmentInfos = (segments) => segments.map(x => <span className={'segment-infos'}><span className={'segment-info-time'}>{`${getAsStartAndEndTimeFormat(x.startDateTime, x.endDateTime)} ${displayDurationInHours(x)}`} {x.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? <CompareArrowsIcon className="segment-info-transfer" /> : ""}</span> {t(`SegmentType.${x.type}`)}</span>);

        let { opened } = this.state;

        const tableComponent = (
            <div style={OpenShiftKeyTable ? { width: '100%' } : { height: 'calc(100vh - 220px)', width: '100%' }}>
                {this.renderTable()}
            </div>
        );
        let tableWithCollapsable = tableComponent;
        const firstData = data[0];
        if (OpenShiftKeyTable) {
            const isOpenShiftSignUp = firstData.requestSubtype === RequestSubtypes.signUp;

            tableWithCollapsable = <StyledEngineProvider injectFirst>
                <ThemeProvider theme={this.theme} >
                    <div className={classes.dataviewTableGroup}>
                        <div className={classes.dataviewTableGroupHeader} >
                            <FontAwesomeIcon className={classes.dataviewTableToggleButton} icon={opened ? faAngleUp : faAngleDown} size={"2x"} onClick={() => { this.toggleCollapsable() }} />
                            <div className={classes.dataviewTableGroupHeaderShift} >
                                <Typography className={classes.shiftTimeTextLarge} style={{ whiteSpace: 'nowrap' }}>
                                    {getAsStartAndEndTimeFormat(firstData.shift.startDateTime, firstData.shift.endDateTime)}
                                    {hasTransfer(firstData.shift) ? ' (X) ' : ' '}
                                    {`(${getAsLongDate(firstData.shift.startDateTime)})`}
                                </Typography>
                            </div>
                            {
                                data.every(x => x.completed)
                                    ?
                                    <CustomToolTip
                                        titleText={"Open shift bid completed"}
                                        jsx={
                                            <div className={classes.dataviewTableGroupHeaderShift} style={{ margin: 16, marginBottom: 0 }}>
                                                <FontAwesomeIcon icon={faCalendarCheck} />
                                            </div>
                                        }
                                    />
                                    :
                                    <div className={classes.dataviewTableGroupHeaderShift} style={{ margin: 20 }} />
                            }
                            {
                                isOpenShiftSignUp
                                    ? (
                                        <>
                                            <div className={classes.dataviewTableGroupHeaderShift} >
                                                <SubmissionPeriodLabel classes={classes} request={firstData} />
                                            </div>
                                            <div className={classes.dataviewTableRecalculateAwarding} >
                                                <CustomToolTip
                                                    titleText={"Run awarding rules"}
                                                    jsx={
                                                        <Button disabled={!managerSetting.adminSettings[0].awardingRuleEnabled} onClick={() => this.props.handleRecalculateAwarding('OS', firstData.openShiftKey)} className={classes.moreOptionsButton} aria-label="more">
                                                            <FontAwesomeIcon className={classes.iconFixHeight} icon={faSyncAlt} />
                                                        </Button>
                                                    }
                                                />
                                            </div>
                                        </>)
                                    :
                                    null
                            }
                        </div>
                        <div className={classes.dataviewTableSegmentInfos}>
                            {displaySegmentInfos(firstData.shift.segments)}
                        </div>
                        <Collapse
                            in={opened}
                            timeout={{ enter: 750, exit: 750 }}
                            style={{ transitionDelay: "250ms" }}
                            mountOnEnter
                            unmountOnExit
                        >

                            {tableComponent}
                        </Collapse>
                    </div>
                </ThemeProvider >
            </StyledEngineProvider>
        }

        return <React.Fragment>{tableWithCollapsable}</React.Fragment>;
    }
}

const mapStateToProps = state => {
    return {
        requestColumns: state.dataviewRequestColumns,
        employee1Columns: state.dataviewEmployee1Columns,
        employee2Columns: state.dataviewEmployee2Columns,
        dataviewsData: state.dataviewsData,
        selectedFetchSize: state.selectedFetchSize,
        fetchSizeOptions: state.fetchSizeOptions,
        managerSettingsList: state.managerSettingsList,
    }
}
const mapDispatchToProps = {
    updateFetchSizeOption
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DataviewTable));